import script from "./ItemPager.vue?vue&type=script&setup=true&lang=ts"
export * from "./ItemPager.vue?vue&type=script&setup=true&lang=ts"

import "./ItemPager.vue?vue&type=style&index=0&id=afe3843c&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afe3843c"]])

export default __exports__